<script>
  import { HowWeWork, ReviewsSlider, store, Advantages, Services, imgSrc, Achievements } from '$client';
  import { MainForm, Faq, MediaSlider, PartnersSlider, Button, Game, Benefits } from '$client';
  import About from './(app)/kompaniya/about.svelte';
  export let data;
  const { other } = store;
  $: home = data.home;
  $: medias = data.medias;
  $: reviews = data.reviews;
  $: catalogs = data.catalogs;
  $: services = { popular: home.services };
  $: data.catalogs.forEach(({ attributes: catalog }) => {
    services[catalog.url] = { header: catalog.ancor, data: catalog.prices };
  });
</script>

<section id="main">
  <section class="container" id="hero">
    <div>
      <h1 class="h1">{@html home.header}</h1>
      <p>{@html home.description}</p>
      <div>
        <Button title={home.buttons[0].header} action={home.buttons[0].href ?? home.buttons[0].modal} />
        <Button
          type="transparent-black"
          title={home.buttons[1].header}
          action={home.buttons[1].href ?? home.buttons[1].modal} />
      </div>
    </div>
    <img
      height="489"
      width="405"
      fetchpriority="high"
      loading="eager"
      src="https://admin.uberi.pro/uploads/mashine_c7e2a42dbf_432acf1fc9.webp"
      alt="Вывоз мусора и ненужных вещей" />
  </section>
  <Services data={services['popular']}>
    <Advantages data={home.advantages} />
    {#if home.text}
      <div class="advantages margin-top">
        <h2 class="h2">{home.text.header}</h2>
        {#if home.text.data}
          <div class="custom-page">{@html home.text.data}</div>
        {/if}
      </div>
    {/if}
  </Services>
  <About {catalogs} type="integrated" data={home.about} />
  <HowWeWork data={home.howWeWork} />
  {#if home.benefits}
    <Benefits data={home.benefits} />
  {/if}
  {#if home.game}
    <Game data={home.game} />
  {/if}
  <section class="container advantages margin-block">
    <h2 class="h2">{home.advantages2.header}</h2>
    <Advantages data={home.advantages2.data} />
  </section>
  <MainForm data={home.form.data.attributes} />
  <ReviewsSlider url="/otzyvy" buttons={false} data={reviews} />
  {#if home.banner?.block}
    <section
      class="container banner"
      style={home.banner.img?.data?.attributes
        ? `background-image: url("${imgSrc(home.banner.img.data.attributes.url)}")`
        : ''}>
      <div>
        {@html home.banner.block}
      </div>
      {#if home.banner.button?.header}
        <Button title={home.banner.button.header} action={home.banner.button.href ?? home.banner.button.modal} />
      {/if}
    </section>
  {/if}
  <PartnersSlider buttons={false} data={$other.partners.data} />
  <MediaSlider url="/media-center" buttons={false} data={medias} />
  <Achievements header={home.achievements.header} data={home.achievements.data} />
  <Faq data={home.faq.data.attributes} />
</section>

<style lang="scss">
  #main {
    display: flex;
    flex-direction: column;

    :global(.faq),
    :global(.about) {
      margin-block: 50px;

      @media only screen and (max-width: 767.98px) {
        margin-block: 30px;
      }
    }
  }

  :global(section[data-class='partners-slider']) {
    padding-block: 80px !important;

    @media only screen and (max-width: 767.98px) {
      padding-block: 30px;
    }
  }

  .banner {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    object-fit: contain;
    overflow-y: auto;
    color: #fff;
    font-family: Roboto;
    // background-color: #2c333c;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    padding-block: 100px;

    :global(> button),
    :global(> a) {
      margin-top: 100px;
    }

    @media only screen and (max-width: 767.98px) {
      padding-block: 50px;
    }
  }

  .advantages h2 {
    margin-bottom: 50px;
    color: #2c333c;
    font-weight: 800;
    font-family: Vela Sans;
  }

  #hero {
    position: relative;
    display: inline-flex;
    justify-content: space-between;
    width: 100%;
    padding-top: 100px;
    padding-bottom: 100px;

    @media only screen and (max-width: 575.98px) {
      padding-bottom: 0;
    }

    @media only screen and (max-width: 991.98px) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      > div {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        align-items: center;
        justify-content: center;
        text-align: center;
      }
    }

    h1 {
      @media only screen and (max-width: 991.98px) {
        :global(br) {
          display: none;
        }
      }

      margin-bottom: 28px;
      font-weight: 800;
      font-family: Vela Sans;

      :global(span) {
        color: #22eaac;
      }
    }

    p {
      margin-bottom: 50px;
      color: #2c333cd9;
      font-weight: normal;
      font-size: 22px;
      font-family: Roboto;

      @media only screen and (max-width: 991.98px) {
        :global(br) {
          display: none;
        }
      }

      @media only screen and (max-width: 575.98px) {
        font-size: 18px;
      }
    }

    > div > div:last-of-type {
      display: inline-flex;
      gap: 24px;
    }

    img {
      position: relative;
      bottom: -110px;
      z-index: -1;
      width: 351px;
      height: 489px;
      margin-bottom: -150px;
      object-fit: contain;

      @media only screen and (max-width: 991.98px) {
        bottom: -100px;
      }

      @media only screen and (max-width: 575.98px) {
        bottom: -20px;
        width: 300px;
        height: 430px;
      }
    }

    &::before {
      position: absolute;
      right: 0;
      bottom: 0;
      z-index: -2;
      width: 55%;
      height: 100%;
      background-color: #22eaac;
      background-image: url('https://admin.uberi.pro/uploads/pattern_87761dc11b.svg');
      background-repeat: repeat;
      background-position: center center;
      background-size: 120%;
      content: '';
      clip-path: polygon(35% 0, 100% 0, 100% 100%, 10% 100%);

      @media only screen and (max-width: 2150px) {
        background-size: 150%;
        clip-path: polygon(45% 0, 100% 0, 100% 100%, 5% 100%);
      }

      @media only screen and (max-width: 1400px) {
        background-size: 180%;
        clip-path: polygon(55% 0, 100% 0, 100% 100%, 5% 100%);
      }

      @media only screen and (max-width: 991.98px) {
        width: 100%;
        height: 350px;
        clip-path: none;
      }

      @media only screen and (max-width: 575.98px) {
        height: 250px;
        background-size: 210%;
      }
    }
  }

  :global(#services) {
    display: flex;
    flex-direction: column;

    :global(> ul:first-child) {
      margin-top: -54px;
    }
  }
</style>
